<!--
 * @Description: 查看同岗位人员数据
 * @Autor: lwq 
 * @Date: 2020-08-15 14:17:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 17:33:46
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\ViewDataOfEmployeesInTheSamePosition\index.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text>
        <!-- 头顶 -->
        <showDataAccessHeader @add='add'
                              :showAdd='!readonly'
                              :label="$t('label_View_data_of_employees_in_the_same_position')"
                              :readonly='readonly'
                              v-model="dataobj.mrbase_sys_data_strategy_same_post_grade_is_used" />
        <!-- 中间内容 -->
        <dataCard v-for="(item,index) in list"
                  :readonly='readonly'
                  class="mb-7"
                  :index=index
                  :key='item.uuid'
                  :list='item'
                  @edit='edit'
                  @deleteItem='deleteItem'>
        </dataCard>
        <!-- 弹出框 -->
      </v-card-text>
      <dialogModule v-model="open"
                    :title="$t('label_View_data_of_employees_in_the_same_position')"
                    :paramsData='currentItem'
                    @getData='getData' />
      <mrc_ess_submitBtn @success='success'
                         v-if="!readonly"
                         :cancelText="$store.state.uuid?$t('label_cancel'):$t('label_The_previous_step')"
                         @cancel='cancel'></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template> 

<script>
import { required } from 'vuelidate/lib/validators'
import {
  listData,
  getData,
  updateData,
  addData,
  delData,
  updatebasis
} from '@/service/api/data-access-strategy'
import showDataAccessHeader from '../showDataAccessHeader'
import dialogModule from './dialogModule'
import dataCard from '../dataCard'
import tree from '../tree'
export default {
  components: { showDataAccessHeader, dialogModule, dataCard, tree },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      skeletonloading: true,
      open: false,
      params: null,
      currentItem: {},
      currentIndex: null,
      dataobj: {
        mrbase_sys_data_strategy_same_post_grade_is_used: '0'
      },
      list: [],
      deleteList: [] //删除的每一项
    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      if (this.$store.state.uuid) {
        this.skeletonloading = true
        const res = await getData({ org_level_uuid: this.$store.state.uuid, date: 'mrbase_sys_data_strategy_same_post_grade' })
        if (res.code == 200) {
          this.list = res.mrbase_sys_data_strategy_same_post_grade ? res.mrbase_sys_data_strategy_same_post_grade : []
          this.dataobj = res.data ? res.data : {}
          this.dataobj.mrbase_sys_data_strategy_same_post_grade_is_used ? '' : this.dataobj.mrbase_sys_data_strategy_same_post_grade_is_used = '0'
        }
        this.skeletonloading = false
      }
      else {

      }
    },
    add () {
      this.currentItem = Object.assign({})
      this.currentIndex = null
      this.open = true
    },
    getData (val, type) { // 0新增 1修改
      this.params = val
      if (type == 1) {
        this.$set(this.list, this.currentIndex, Object.assign(this.currentItem, val))
      }
      else {
        this.list.push(val)
      }
    },
    edit (item, index) {  //修改
      this.currentItem = item
      this.currentIndex = index
      this.open = true
    },
    deleteItem (item, index) { //删除
      this.currentItem = item
      this.currentIndex = index
      if (item.uuid) {
        this.deleteList.push({ ...item, type: 'del' })
      }
      this.list.splice(index, 1)
    },
    async success () {
      if (this.$store.state.uuid) {//修改
        let arr = [...this.list, ...this.deleteList].map(item => {
          return { ...item, strategy_uuid: this.dataobj.uuid }
        })
        const res = await updateData({
          '~table~': 'mrbase_sys_data_strategy_same_post_grade',
          "mrbase_sys_data_strategy_same_post_grade_properties": "003", //同岗位的相互查看数据权限 策略uuid
          org_level_uuid: this.$store.state.uuid,
          mrbase_sys_data_strategy_same_post_grade_is_used: this.dataobj.mrbase_sys_data_strategy_same_post_grade_is_used,
          mrbase_sys_data_strategy_same_post_grade: arr
        })
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_The_modification_was_successful') })
          await this.getList()
          this.$emit('updateSuccess')
        }
        // else {
        //   this.$Message({ text: this.$t(res.msg), color: 'rgba(0, 0, 0, 0.38) ' })
        // }
      }
      else {//新增
        this.$emit('success')
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getList()
        this.$emit('updateSuccess')
      }
      else {
        this.$emit('cancel')
      }
    }
  },
};
</script>

<style scoped>
</style>
